import axios from 'src/axios'
import { TUTORAPPROUTES } from 'src/router/Api'

export interface FindMyTutorListParams {
	page?: number
	limit?: number
	q?: string
	country?: string
	language_ids?: string[]
	sort?: string
}

export type FindMyTutorCmsType = 'tutor' | 'learner' | 'course' | 'post'

export const getTutorForLearner = async (params: FindMyTutorListParams) => {
	return await axios.get(TUTORAPPROUTES.tutorForLearner, {
		params,
	})
}

export const getLearnerForTutor = async (params: { page?: number; limit?: number }) => {
	return await axios.get(TUTORAPPROUTES.learnerForTutor, {
		params,
	})
}

export const getLearnerMyPosts = async (params: { page?: number; limit?: number }) => {
	return await axios.get(TUTORAPPROUTES.learnerMyPosts, {
		params,
	})
}

export const getTutorMyCourses = async (params: { page?: number; limit?: number }) => {
	return await axios.get(TUTORAPPROUTES.myCourses, {
		params,
	})
}

export const getTutorMyCoursesUniVini = async (params: { page?: number; limit?: number }) => {
	return await axios.get(TUTORAPPROUTES.myCoursesUniVini, {
		params,
	})
}

export const getFindMyTutorCmsStatistics = async () => {
	return await axios.get(TUTORAPPROUTES.cmsStatistics)
}

export const getFindMyTutorCmsCountries = async (params: FindMyTutorListParams) => {
	return await axios.get(TUTORAPPROUTES.cmsCountries, {
		params,
	})
}

export const getFindMyTutorCmsList = async (
	type: FindMyTutorCmsType,
	params: FindMyTutorListParams,
) => {
	return await axios.get(TUTORAPPROUTES.cmsList(type), {
		params,
	})
}

export const hideFindMyTutorCmsItem = async (
	type: FindMyTutorCmsType,
	id: string,
	isHidden?: boolean,
) => {
	return await axios.patch(TUTORAPPROUTES.cmsHide(type, id), {
		is_hidden: isHidden,
		status: typeof isHidden === 'boolean' ? !isHidden : undefined,
	})
}

export const deleteFindMyTutorCmsItem = async (
	type: FindMyTutorCmsType,
	id: string,
) => {
	return await axios.delete(TUTORAPPROUTES.cmsItem(type, id))
}
